import { CarmResources } from '@carm/_core';
import { ProgramTypes } from './user-role.model';

export interface IAcl {
  resource: CarmResources;
  group: GroupTypes;
  isNativeAcl?: boolean;
}

export interface IAclProgram {
  resourceName: CarmResources;
  allowedPrograms?: ProgramTypes[];
}

/* Lower the number higher the priority */
export enum GroupTypes {
  SuperAdmin = 1,
  Admin = 2,
  Manager = 3,
  Editor = 4,
  Creator = 5,
  Reader = 6
}
